import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import qs from 'qs';

export function useGetQuerySort() {
  const location = useLocation();
  const navigate = useNavigate();
  const sortField = qs.parse(location.search.substr(1))['sort-field'];
  const sortOrder = qs.parse(location.search.substr(1))['sort-order'];
  return {
    sortField,
    desc: (sortOrder || '').toLowerCase() === 'desc',
    onChangeSort: (field: string, newOrder: 'asc' | 'desc') => {
      const params = {
        'sort-field': field,
        'sort-order': newOrder,
      };
      const options = {
        pathname: location.pathname,
        search: `?${createSearchParams(params)}`,
      };
      navigate(options, { replace: true });
    },
  };
}
